window.initGoogleMap = function () {
  if (!window.google) return;

  var input = document.querySelector("input[data-location]");

  if (input) {
    var options = {
      fields: ["address_components"],
      types: ["(cities)"],
    };
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    input.dataset.chosen = input.value ? 'true' : 'false';

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.address_components) return;
      var components = place.address_components;
      function find(type) {
        var comp = components.find(function (c) { return c.types.indexOf(type) >= 0; });
        return comp ? comp.long_name : null;
      }
      var city = find('locality') || find('administrative_area_level_2') || find('postal_town') || find('administrative_area_level_1') || find('colloquial_area');
      var country = find('country');
      if (country) {
        input.value = city ? (city + ', ' + country) : country;
        input.dataset.chosen = 'true';
        input.setCustomValidity('');
      }
    });

    // Mark as not chosen if user edits manually
    input.addEventListener('input', function () { this.dataset.chosen = 'false'; this.setCustomValidity(''); });

    // On blur, set a validation message if not chosen from suggestions
    input.addEventListener('blur', function () {
      if (this.required && this.dataset.chosen !== 'true') {
        this.setCustomValidity("Sélectionne une ville dans la liste des suggestions.");
      } else {
        this.setCustomValidity('');
      }
    });
  }
};

document.addEventListener("turbo:load", function () {
  initGoogleMap();
});

// Pre-submit click guard: prevents Turbo submit when invalid, so button never gets disabled
// Validates before submission and focuses the field
(function () {
  var MESSAGE = "Sélectionne une ville dans la liste des suggestions.";

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[type=submit], input[type=submit]');
    if (!btn) return;
    var form = btn.form || (btn.closest && btn.closest('form'));
    if (!form) return;

    var locInput = form.querySelector && form.querySelector('input[data-location]');
    if (locInput && locInput.required && locInput.dataset.chosen !== 'true') {
      e.preventDefault();
      locInput.setCustomValidity(MESSAGE);
      if (typeof form.reportValidity === 'function') form.reportValidity();
      locInput.focus();
    } else if (locInput) {
      locInput.setCustomValidity('');
    }
  }, true);
})();
